import { usePathname } from "hooks/usePathName";
import React, { useEffect, useRef } from "react";
import { Container } from "./styles";
import { ReactComponent as PlayBtn } from "assets/playbtn.svg";
import HomePageImage from "assets/new-hero-design.png"; // homepageImage.png
import ellipse1 from "assets/ellipse1.png";
import ellipse2 from "assets/ellipse2.png";
import HowItWorksVideo from "component/HowItWorksVideo";
// import {gsap} from "gsap";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

function Index({ bg, title, desc, btnText, onClick, addEllipse, descStyle, titleTip, ...props }) {
  const location = usePathname();
  const [isOpen, setOpen] = React.useState(false);
  let titleRef = useRef(null);
  let descriptionRef = useRef(null);

  /*const handleVideo =() => {
    console.log("Video");
    setOpen(true);
  };*/

  useEffect(() => {
    // gsap.from(descriptionRef.current, {y:-10, duration:1});
    // gsap.from(titleRef.current, { y: 20, duration: 1, opacity: 0, delay: .5 });
    AOS.init();
  }, []);

  return (
    <Container background={HomePageImage} fontColor={location === "/"} {...props}>
      <HowItWorksVideo isOpen={isOpen} onClose={() => setOpen(false)} />
      {addEllipse && (
        <div className="ellipseWrapper">
          <div className="ellipse1">
            <img src={ellipse1} alt="ellipse" />
          </div>
          <div className="ellipse2">
            <img src={ellipse2} alt="ellipse" />
          </div>
        </div>
      )}
      <div className="wrapper">
        <div className="text-content">
          {titleTip && <span className="title-tip">{titleTip}</span>}
          <h1 className="title" ref={titleRef}>
            {title}
          </h1>
          <p
            className="desc"
            ref={descriptionRef}
            style={descStyle}
            data-aos="fade-up"
            data-aos-duration="800"
          >
            {desc}
          </p>
          {btnText && (
            <div className="btn">
              <button className="first-btn" onClick={onClick}>
                {btnText}
              </button>
              <div>
                <PlayBtn />
                <Link to="/#how-it-works" className="sec-link">
                  How it works
                </Link>
              </div>
            </div>
          )}
        </div>
        <div className="img-content"></div>
      </div>
    </Container>
  );
}

export default Index;
